import {useTranslation} from "react-i18next";
import {Button, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {ROUTES} from "../../router/config";
import "./CompletePage.css";

const CompletePage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="CompletePage">
            <Typography variant="h1" className="mt-4" gutterBottom>
                {t("complete.title")}
            </Typography>
            <Typography variant="body1" className="mt-4">
                {t("complete.subtitle")}
            </Typography>
            <div className="divider mt-8 mb-8" />
            <Typography variant="body1" className="mt-4" gutterBottom>
                {t("complete.questions")}
                <a href={`mailto:${t("complete.email")}`}>{t("complete.email")}</a>
            </Typography>
            <Button
                variant="accent"
                size="large"
                className="mt-4"
                onClick={() => navigate(ROUTES.WELCOME)}
            >
                {t("complete.returnHome")}
            </Button>
        </div>
    );
};

export default CompletePage;
